import React from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { BasePageProps, Page } from "@/uiKit/atoms/page/Page.tsx";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BasePageWithDrawerProps = {
  drawer: React.ReactNode;
} & BasePageProps;

export type PageWithDrawerProps = AtomProps<BasePageWithDrawerProps, StyleClasses<"root" | "content">>;

export const PageWithDrawer: React.FC<PageWithDrawerProps> = ({
  id,
  className,
  classes,
  drawer,
  children,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <Page id={id} className={cx(styles.root, className, classes?.root)} {...props}>
      <div className={cx(styles.content, classes?.content)}>{children}</div>
      {drawer}
    </Page>
  );
};

const makeStyles = () => ({
  root: css({
    display: "flex",
    flexDirection: "row",
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    maxWidth: "100%",
    minWidth: 0,
  }),
});
